import React, { useEffect, useState } from 'react';
import { AppLayout } from '@/components/AppLayout';
import { AGENT_LINKS } from './links';
import { agentApi } from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { TID } from '@/constants/testIds';
import { Loader } from '@/components/Loader';

export default function AgentEcheances() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await agentApi.listBailleurs();
        // Sort by expiration date ascending
        const sorted = data.sort((a, b) => (a.subscription?.expires_at || '').localeCompare(b.subscription?.expires_at || ''));
        setItems(sorted);
      } finally { setLoading(false); }
    })();
  }, []);

  const now = new Date();
  const badge = (exp) => {
    if (!exp) return null;
    const d = new Date(exp);
    const days = Math.round((d - now) / (1000 * 60 * 60 * 24));
    if (days < 0) return <Badge className="bg-red-50 text-red-700 border border-red-200 hover:bg-red-50">Expiré</Badge>;
    if (days <= 30) return <Badge className="bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-50">{days}j restants</Badge>;
    if (days <= 60) return <Badge className="bg-[#E6F1FF] text-[#1677FF] border border-[#BEDBFF] hover:bg-[#E6F1FF]">Bientôt ({days}j)</Badge>;
    return <Badge className="bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-50">OK</Badge>;
  };

  return (
    <AppLayout links={AGENT_LINKS} testid={TID.agentSidebar} title="Échéances abonnements">
      <div className="lb-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left">
                {['Bailleur', 'Offre', 'Prix', 'Expire le', 'Statut'].map((h) => (
                  <th key={h} className="px-4 py-3 text-[11px] font-semibold uppercase tracking-widest text-slate-500">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={5} className="px-4 py-8"><Loader variant="full" /></td></tr>}
              {!loading && items.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">Aucun abonnement à suivre.</td></tr>
              )}
              {items.map((b) => (
                <tr key={b.id} className="border-b border-slate-100">
                  <td className="px-4 py-3">
                    <div className="font-semibold text-[#0D1B2A]">{b.prenom} {b.nom}</div>
                    <div className="text-xs text-slate-500">{b.email}</div>
                  </td>
                  <td className="px-4 py-3 capitalize font-medium text-[#0D1B2A]">{b.subscription?.offer}</td>
                  <td className="px-4 py-3 font-bold text-[#0D1B2A]">${b.subscription?.price_usd}/an</td>
                  <td className="px-4 py-3 text-slate-700">{b.subscription?.expires_at ? new Date(b.subscription.expires_at).toLocaleDateString('fr-FR') : '—'}</td>
                  <td className="px-4 py-3">{badge(b.subscription?.expires_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppLayout>
  );
}
